
import React, { PropTypes } from 'react';

export default function Button(props) {
  const {
    disabled = false,
    label = null,
    className = 'button-main',
    onClick,
    ...otherProps
  } = props;

  const currentClass = (disabled) ? `${className} disabled` : className;

  const handleClick = (event) =>
    (!disabled && onClick) ? onClick(event) : null;

  return (
    <a
      className={currentClass}
      data-id={label}
      onClick={handleClick}
      {...otherProps}
    >
      <div>{label}</div>
    </a>
  );
}



// WEBPACK FOOTER //
// ./shared/common/components/Button.js